import ActionControl from "./ActionControl";
import ContextMenu from "./ContextMenu";
import * as _ from "lodash";
import * as React from "react";
class ActionContextMenu extends React.Component {
    static ACTION_PROPS = [
        "filter",
        "group",
        "instanceId",
        "staticElements",
    ];
    render() {
        const actionProps = _.pick(this.props, ActionContextMenu.ACTION_PROPS);
        const menuProps = _.omit(this.props, ActionContextMenu.ACTION_PROPS);
        return (React.createElement(ActionControl, { ...actionProps },
            React.createElement(ContextMenu, { ...menuProps })));
    }
}
export default ActionContextMenu;
